export default function pagination({ variables, }) {
    return {
        MuiPagination: {
            defaultProps: {
                variant: "outlined",
                shape: "rounded",
                size: "small",
            },
            styleOverrides: {
                ul: {
                    gap: variables.spacing_01,
                    flexWrap: "nowrap",
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    minWidth: "24px",
                    height: "24px",
                    margin: 0,
                    borderRadius: variables.border_radius_small,
                    color: variables.text_medium,
                    fontFamily: variables.type_caption_font_family,
                    fontSize: variables.type_caption_font_size,
                    "&.Mui-disabled": {
                        color: variables.text_disabled,
                        opacity: "inherit",
                        borderColor: variables.border_subtle,
                    },
                },
                outlined: {
                    borderColor: variables.border_subtle,
                    backgroundColor: variables.surface,
                },
                page: {
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "&.Mui-selected": {
                        borderColor: variables.border_interactive,
                        backgroundColor: variables.surface_selected,
                        color: variables.interactive_text,
                        fontWeight: variables.font_weight_semibold,
                        "&:hover": {
                            backgroundColor: variables.surface_selected,
                        },
                    },
                },
                ellipsis: {
                    minWidth: "24px",
                    height: "24px",
                    border: "none",
                    backgroundColor: "transparent",
                },
            },
        },
    };
}
//# sourceMappingURL=pagination.js.map